module.exports = __webpack_public_path__ + "static/media/Time-Table---Miss-Jumana.2ee47554.jpg";